import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { Button, Label } from '@shared/ui';

import { clubCheckLanguage } from '../../model';

export const ClubCheck = () => {
  return (
    <div className='flex flex-col gap-4 items-center justify-center max-w-[440px]'>
      <Image src='/resources/bashgahLogo.svg' alt='bashgah' width={140} height={100} />
      <Label className='h5-bold'>{clubCheckLanguage.clubCheck}</Label>

      <Link
        target='_blank'
        href={'https://bashgah.com/Intro/?utm_source=myagah&utm_medium=cta&utm_content=profile'}
        className='w-full h-auto items-start flex justify-center mt-4'
      >
        <Button className='h-[60px] w-full gap-x-1' type='submit'>
          {clubCheckLanguage.clubCheckButton}
        </Button>
      </Link>
    </div>
  );
};
